import { css, cx } from "@emotion/css"
import React from "react"

import type MyPageFormField from "./MyPageFormField"

type Props = {
  children: React.ReactNode
  layout: "alignCenter" | "full"
  fieldWidth: number
  gap?: number
}

const MyPageForm = ({ children, layout, fieldWidth, gap }: Props) => {
  const newProps: Pick<React.ComponentProps<typeof MyPageFormField>, "labelAlign" | "fieldWidth"> = {
    labelAlign: layout === "full" ? "left" : "right",
    fieldWidth,
  }
  const formClassName = cx(styles.form, layout === "full" && styles.full)

  const onSubmit = (e: React.FormEvent) => {
    // form内のinput要素が1つだけの場合、Enterキー押下でsubmitイベントが発生しフォームが送信されてしまうため、それを抑制します。
    // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#implicit-submission
    e.preventDefault()
  }

  return (
    <div className={styles.container}>
      <form onSubmit={onSubmit} noValidate className={formClassName} style={{ rowGap: gap }}>
        {React.Children.map(children, (child) => {
          return React.isValidElement(child) ? React.cloneElement(child, newProps) : child
        })}
      </form>
    </div>
  )
}

export default MyPageForm

const styles = {
  container: css`
    display: flex;
    justify-content: center;
  `,
  form: css`
    display: flex;
    flex-direction: column;
  `,
  full: css`
    width: 100%;
  `,
}
